
import { options } from '~/plugins/gmap.js'

export default {
  props: {
    locations: {
      type: Array,
      required: true,
    },
  },

  data: () => ({
    options,
    center: { lat: 47.4768892, lng: 7.7239866 },
    icon: {
      url: '/gmap-marker.svg',
      scaledSize: { height: 110, width: 180 },
    },
  }),

  mounted() {
    if (!this.locations[0]) return

    this.center = {
      lat: parseFloat(this.locations[0]?.lat || 47.4768892),
      lng: parseFloat(this.locations[0]?.lng || 7.7239866),
    }
  },

  methods: {
    visibilityChanged(isVisible, entry, location) {
      if (!isVisible) return

      this.$refs.gmap.$mapPromise.then((map) => {
        map.panTo({
          lat: parseFloat(location.lat),
          lng: parseFloat(location.lng),
        })
      })
    },
  },
}
